import React from 'react';
import MuiTabs from '@mui/material/Tabs';
import { FlexProps, NativeAttributes } from 'pounce';
import { useTabsContext } from './Tabs';

export type TabListProps = NativeAttributes<'div'> &
  FlexProps & { children: React.ReactNode | React.ReactNode[] };

const TabList = React.forwardRef<HTMLDivElement, TabListProps>(function TabList(
  { children, ...rest },
  ref,
) {
  const { selectedIndex, setSelectedIndex, orientation, size, variant } = useTabsContext();

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    setSelectedIndex(newValue);
  };

  return (
    <MuiTabs
      value={selectedIndex}
      onChange={handleChange}
      orientation={orientation}
      data-size={size}
      data-variant={variant}
      {...rest}
      ref={ref}
    >
      {React.Children.toArray(children).map((child, index) =>
        React.cloneElement(child as React.ReactElement<any>, {
          isSelected: selectedIndex === index,
          isFocused: selectedIndex === index,
        }),
      )}
    </MuiTabs>
  );
});

export default TabList;
